import UploadFileComponent from './UploadFileComponent';
export default UploadFileComponent;
